import React from 'react'
import './sub-subtask-2023.css'

const SubSubtask2023 = ({subtask, sub2x, setOpenModal2023, imEditingATemplate}) => {

    const changeName = (val) => {
        setOpenModal2023(prev => ({...prev, todoSubtasks: prev.todoSubtasks.map((sub) => sub.subtaskId === subtask.subtaskId ? {...sub, subtaskSubtasks: sub.subtaskSubtasks.map((subsub) => subsub.subtask2xId === sub2x.subtask2xId ? {...subsub, subtask2xName: val} : subsub)} : sub)}))
    }

    const toggleCheckbox = () => {
        imEditingATemplate ? setOpenModal2023(prev => ({...prev, todoSubtasks: prev.todoSubtasks.map((sub) => sub.subtaskId === subtask.subtaskId ? {...sub, subtaskSubtasks: sub.subtaskSubtasks.filter((subsub) => subsub.subtask2xId !== sub2x.subtask2xId && subsub)} : sub)}))
        : setOpenModal2023(prev => ({...prev, todoSubtasks: prev.todoSubtasks.map((sub) => sub.subtaskId === subtask.subtaskId ? {...sub, subtaskSubtasks: sub.subtaskSubtasks.map((subsub) => subsub.subtask2xId === sub2x.subtask2xId ? {...subsub, subtask2xCompleted: !subsub.subtask2xCompleted} : subsub)} : sub)}))
    }

    const checkForAutoClear = (val) => {
        val === "New mini todo..." && setOpenModal2023((prev) => ({...prev, todoSubtasks: prev.todoSubtasks.map((sub) => sub.subtaskId === subtask.subtaskId ? {...sub, subtaskSubtasks: sub.subtaskSubtasks.map((subsub) => subsub.subtask2xId === sub2x.subtask2xId ? {...subsub, subtask2xName: ''} : subsub)} : sub)}))
    }

    return(
        <div className='sub-subtask-2023__wrapper'>
            <div className='sub-subtask-2023__checkbox' onClick={toggleCheckbox} style={sub2x.subtask2xCompleted ? {backgroundColor: 'green', color: 'gray' } : {backgroundColor: '#fff', color: 'black' }}></div>
            <input className='sub-subtask-2023__name' value={sub2x.subtask2xName} onClick={(e) => checkForAutoClear(e.target.value)} onChange={(e) => changeName(e.target.value)}  />
        </div>
    )
}
export default SubSubtask2023;